module.exports = __webpack_public_path__ + "img/Bear25.84bee5cc.jpg";